var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttendanceNotMarked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 15.625C16.55 15.625 13.75 18.425 13.75 21.875C13.75 25.325 16.55 28.125 20 28.125C23.45 28.125 26.25 25.325 26.25 21.875C26.25 18.425 23.45 15.625 20 15.625ZM22.0625 24.8125L19.375 22.125V18.125H20.625V21.6125L22.9375 23.925L22.0625 24.8125ZM21.25 4.375H17.275C16.75 2.925 15.375 1.875 13.75 1.875C12.125 1.875 10.75 2.925 10.225 4.375H6.25C4.875 4.375 3.75 5.5 3.75 6.875V25.625C3.75 27 4.875 28.125 6.25 28.125H13.8875C13.15 27.4125 12.55 26.5625 12.1125 25.625H6.25V6.875H8.75V10.625H18.75V6.875H21.25V13.225C22.1375 13.35 22.975 13.6125 23.75 13.975V6.875C23.75 5.5 22.625 4.375 21.25 4.375ZM13.75 6.875C13.0625 6.875 12.5 6.3125 12.5 5.625C12.5 4.9375 13.0625 4.375 13.75 4.375C14.4375 4.375 15 4.9375 15 5.625C15 6.3125 14.4375 6.875 13.75 6.875Z",
    fill: "#E53E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttendanceNotMarked);
export default __webpack_public_path__ + "static/media/Attendance Not Marked.2dbdd48610430dda2b18e8d740809f5e.svg";
export { ForwardRef as ReactComponent };